import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { RouteBar } from '../index';
import styles from './styles';

class SelectedPoiDetails extends React.PureComponent {
  render() {
    const {
      classes,
      selectedPoi,
      t,
      route,
      route: { distance, time },
      addStopInProgressStatus,
      incoming_poi,
    } = this.props;
    const poi = addStopInProgressStatus ? incoming_poi : selectedPoi;
    return (
      <React.Fragment>
        <span className={classes.header__container}>
          {poi.name !== undefined ? (
            <Typography className={classes.title}>
              {poi.name}
              {poi.poi !== undefined && poi.poi.marketEnabled ? (
                <i className={`material-icons ${classes.mp}`}>local_mall</i>
              ) : null}
            </Typography>
          ) : (
            <Typography className={classes.title}>
              {poi.latitude}
              {t('poi-list.label.comma')} {poi.longitude}
              {poi.poi !== undefined && poi.poi.marketEnabled ? (
                <i className={`material-icons ${classes.mp}`}>local_mall</i>
              ) : null}
            </Typography>
          )}
          {poi.address !== undefined ? (
            <Typography className={classes.subtitle}>{poi.address}</Typography>
          ) : (
            <Typography className={classes.subtitle}>
              {poi.latitude}
              {t('poi-list.label.comma')} {poi.longitude}
            </Typography>
          )}
        </span>
        {distance === undefined ? null : (
          <React.Fragment>
            <span className={classes.time__container}>
              <Typography className={classes.min}>{`${time}`}</Typography>
              <Typography className={classes.dot}>{t('poi-list.label.dot')}</Typography>
              <Typography className={classes.mile}>{`${distance}`}</Typography>
            </span>
            <RouteBar route={route} />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

SelectedPoiDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  selectedPoi: PropTypes.object,
  incoming_poi: PropTypes.object,
  route: PropTypes.object,
  addStopInProgressStatus: PropTypes.bool,
};

SelectedPoiDetails.defaultProps = {
  selectedPoi: {},
  incoming_poi: {},
  addStopInProgressStatus: false,
  route: {
    distance: '',
    time: '',
  },
};

const mapStateToProps = ({ poi }) => ({
  selectedPoi: poi.selected_poi,
  route: poi.route,
  addStopInProgressStatus: poi.stops_inprogress,
  incoming_poi: poi.incoming_stop,
});

const mapDispatchToProps = () => ({});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(SelectedPoiDetails)),
);
